import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState, formatMessage } from 'src/api';
import { FormattedMessage } from 'react-intl';
import MESSAGES from './CheckoutParts.messages';
import { PricingsDispatcher } from 'src/app/Container/Dispatcher/PricingsDispatcher';
import { formatPeriod } from 'src/app/Partials/Admin/Pricing/Pricings';
import { requestAPIActions } from 'loopback-react-request';
import { Input } from 'reactstrap';
import PeriodSelectionDropdown from './PeriodSelectionDropdown';
import { userIsInternal, userIsSalesRep } from 'src/app/Partials/Admin/utils';

export interface PeriodSelectionProps {
  checkout: GlobalPrivateState['checkout'];
  configuration: GlobalPrivateState['configuration'];
  pricings: GlobalPrivateState['pricings'];
  dispatch: Function;
  user: GlobalPrivateState['user'];
}

export class PeriodSelectionPartial extends React.Component<PeriodSelectionProps, any> {
  constructor(props: PeriodSelectionProps) {
    super(props);
  }

  render() {
    const {
      configuration,
      pricings,
      checkout
    } = this.props;

    const isOffer = this.currentStatus === 'offer';
    const isOrder = this.currentStatus === 'order';

    // Maybe selectedPeriodAccessories comes from configuration if it exists, otherwise state
    const selectedPeriodAccessories = configuration.result && configuration.result.pricingsAccessoriesId 
      || configuration.result && configuration.result.pricingsAccessories && configuration.result.pricingsAccessories.id 
      || checkout.result && checkout.result.pricingsAccessoriesIdFallback;
    const selectedPeriodWashbasin = configuration.result && configuration.result.pricingsWashbasinId 
      || configuration.result && configuration.result.pricingsWashbasin && configuration.result.pricingsWashbasin.id 
      || checkout.result && checkout.result.pricingsWashbasinIdFallback;

    const isDisabled = configuration.updating;

    const isInternalUser = this.props.user && this.props.user.result && (userIsInternal(this.props.user.result) || userIsSalesRep(this.props.user.result));

    return (
      <>
        {isInternalUser && !isOffer && !isOrder && configuration.result && (
          <>
            <PricingsDispatcher />

            {pricings && pricings.result && (
              <>
                <div className="col-12 mt-3">
                  <small><strong className="d-block"><FormattedMessage {...MESSAGES.timePeriodNote} /></strong> <FormattedMessage {...MESSAGES.timePeriodNoteText} /></small>
                </div>
                <div className="col-12 mt-3">
                  <PeriodSelectionDropdown 
                    pricings={pricings} 
                    selectedPeriod={selectedPeriodAccessories} 
                    type="accessories" 
                    isDisabled={isDisabled} 
                    onChange={this.onChangePeriod} 
                    label={formatMessage({...MESSAGES.timePeriodAccessoriesLabel})} />
                </div>
                <div className="col-12 mt-3">
                  <PeriodSelectionDropdown 
                    pricings={pricings} 
                    selectedPeriod={selectedPeriodWashbasin} 
                    type="washbasin" 
                    isDisabled={isDisabled} 
                    onChange={this.onChangePeriod} 
                    label={formatMessage({...MESSAGES.timePeriodWashbasinLabel})} />
                </div>
              </>
            )}
          </>
        )}
      </>
    );
  }

  onChangePeriod = (event: any, type: string): void => {
    const {
      configuration,
      dispatch
    } = this.props;
    
    const newId = event.target.value;
    const newData: any = {};

    if (type === 'accessories') {
      newData.pricingsAccessoriesId = newId;
    }

    if (type === 'washbasin') {
      newData.pricingsWashbasinId = newId;
    }
    
    // Update config...
    this.props.dispatch(requestAPIActions.load(
      'configuration', {
        url: `/Configurations/${configuration.result && configuration.result.id}`,
        options: {
          method: 'PATCH',
          data: newData
        },
      },
      true
    ));
  }

  get currentStatus() {
    const currentStatus = (this.props.configuration.result && this.props.configuration.result.completionStatus) || 'draft';
    return currentStatus;
  }
}


export const PeriodSelection = connect((state: GlobalPrivateState) => ({
  checkout: state.checkout,
  configuration: state.configuration,
  pricings: state.pricings,
  user: state.user
}))(PeriodSelectionPartial);

export default PeriodSelection;